import React from 'react';
import { graphql, compose, withApollo } from 'react-apollo';
import {
  Input,
  Tooltip,
  notification,
  Button,
  Modal,
  Select,
  DatePicker,
} from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

import _ from 'lodash';

import confirmarDepositoContravencional from '../../../graphql/mutations/contravenciones/confirmarDepositoContravencional.graphql';
import getSucursales from '../../../graphql/querys/organismos/getSucursales.graphql';
import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import { Radio } from 'antd';

const FormItem = Form.Item;
const { TextArea } = Input;
const Option = Select.Option;

@compose(
  graphql(confirmarDepositoContravencional, {
    name: 'confirmarDepositoContravencional',
  }),
  graphql(getUsuario),
  graphql(getSucursales, { name: 'getSucursales' }),
  graphql(getOrganismos, { name: 'getOrganismos' })
)
class ConfirmarDepositosContravencion extends React.Component {
  onSubmit = e => {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        values.fechaDeposito = values.fechaDeposito.toDate();
        this.confirmarDepositoContravencional(values);
      }
    });
  };

  confirmarDepositoContravencional = valores => {
    // console.log("Estoy en el confirmar recepcion");
    // console.log(valores);

    this.props
      .confirmarDepositoContravencional({
        variables: {
          _id: this.props.match.params.id,
          fechaDeposito: valores.fechaDeposito,
          idSucursal: valores.idSucursal,
          numBoletaDeposito: valores.numBoletaDeposito,
          observacion: valores.observacion,
          nombreBancoTransferencia: valores.nombreBancoTransferencia,
          tipo: valores.tipo,
        },
      })
      .then(res => {
        // console.log("Me volvio...");
        // console.log(res.data.confirmarDepositoContravencional);

        if (res.data.confirmarDepositoContravencional) {
          notification.success({
            message: 'Confirmacion guardada con exito',
            description: 'Se ha registrado los nuevos datos del envio',
          });

          this.props.history.push('/');
        }
      })
      .catch(err => {
        console.log('Error en la confirmacion de la recepcion');
        console.log(err);

        Modal.error({
          title: 'Error en la confirmacion de la recepción',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  crearOpciones(sucursal) {
    return (
      <Option key={sucursal._id} value={sucursal._id}>
        {sucursal.nombre}
      </Option>
    );
  }

  onChangeTipo = e => {
    this.setState({
      ...this.state,
      tipo: e.target.value,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    let listaSucursales = this.props.getSucursales.getSucursales;
    if (listaSucursales) {
      var opciones = _.map(listaSucursales, this.crearOpciones);
    }

    return (
      <div>
        <h1 className="tituloForm">Datos de deposito efectivo</h1>
        <Form
          onSubmit={this.onSubmit}
          style={{ marginTop: 50, marginRight: 40 }}
        >
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Fecha de deposito
                <Tooltip title="Seleccione la fecha de que se efectuo el deposito">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('fechaDeposito', {
              rules: [
                {
                  type: 'object',
                  required: true,
                  message: 'Por favor, seleccione la fecha del deposito',
                },
              ],
            })(
              <DatePicker
                style={{ width: 400 }}
                placeholder="Fecha de deposito"
                format="DD/MM/YYYY"
              />
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Tipo
                <Tooltip title="Seleccione si es un Deposito Bancario o Transferencia">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('tipo', {
              rules: [
                {
                  type: 'string',
                  required: true,
                  message: 'Por favor, seleccione el tipo de operación',
                },
              ],
            })(
              <Radio.Group onChange={this.onChangeTipo}>
                <Radio value={'deposito'}>Deposito Bancario</Radio>
                <Radio value={'transferencia'}>Transferencia</Radio>
              </Radio.Group>
            )}
          </FormItem>

          {this.props.form.getFieldValue('tipo') === 'deposito' && (
            <FormItem
              {...formItemLayout}
              label={
                <span>
                  Nombre de la Sucursal
                  <Tooltip title="Nombre de la Sucursal del BPN donde se depositó">
                    <Icons.QuestionCircleOutlined />
                  </Tooltip>
                </span>
              }
            >
              {getFieldDecorator('idSucursal', {
                rules: [
                  {
                    required: true,
                    message: 'Por favor, ingresar el nombre de la sucursal!',
                    whitespace: true,
                  },
                ],
              })(
                <Select
                  showSearch
                  style={{ width: 400, marginRight: 20 }}
                  placeholder="Seleccione una sucursal"
                  optionFilterProp="children"
                  onChange={this.handleChange}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {opciones}
                </Select>
              )}
            </FormItem>
          )}

          {this.props.form.getFieldValue('tipo') === 'transferencia' && (
            <FormItem
              {...formItemLayout}
              label={
                <span>
                  Nombre del Banco
                  <Tooltip title="Nombre del Banco">
                    <Icons.QuestionCircleOutlined />
                  </Tooltip>
                </span>
              }
            >
              {getFieldDecorator('nombreBancoTransferencia', {
                rules: [
                  {
                    required:
                      this.props.form.getFieldValue('tipo') === 'transferencia',
                    message: 'Por favor, ingresar el nombre del banco!',
                    whitespace: true,
                  },
                ],
              })(<Input style={{ width: 400 }} />)}
            </FormItem>
          )}

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Numero de Referencia
                <Tooltip title="Numero que aparece en el comprobante del deposito">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('numBoletaDeposito', {
              rules: [
                {
                  required: true,
                  message:
                    'Por favor, ingresar el numero de forma correcta, sin puntos!',
                  validator: this.checkNumero,
                },
              ],
            })(<Input style={{ width: 400 }} />)}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Observación
                <Tooltip title="Si lo desea, puede agregar algun comentario del envio">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('observacion', {})(
              <TextArea style={{ width: 400 }} rows={4} />
            )}
          </FormItem>
          <FormItem {...tailFormItemLayout}>
            <Button
              type="primary"
              htmlType="submit"
              style={{ marginLeft: '25%' }}
            >
              Confirmar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create()(withApollo(ConfirmarDepositosContravencion));
